import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

type ArrowDirection = 'left' | 'right';

export const Wrapper = styled.div`
    display: flex;
    z-index: 3;
    flex-direction: row;
`;

export const Arrow = styled.div<{ direction?: ArrowDirection }>`
    @media (max-width: ${wideBreakpoints.mobile}) {
        display: none;
    }

    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transition: 0.3s background-color;
    background-color: ${COLORS.BgLight};
    background-image: url('/static/images/icons/arrow_carousel.svg');
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    opacity: 0.5;

    ${({ direction }) =>
        direction === 'left' ? 'transform: rotate(180deg);' : ''}
    :hover {
        background-color: ${COLORS.BgMain};
        opacity: 1;
    }
`;

export const ShowAllButton = styled(BaseButton)`
    margin-right: 24px;
    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-right: 0px !important;
    }
`;
